import React, { useState, useEffect } from 'react';
import {config} from "../../shared/config";
import * as util from '../../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../../shared/ShowError';
import Laoding from '../../shared/Laoding';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import ClientCombo from '../../combos/ClientCombo';
import ProductCombo from '../../combos/ProductCombo';
import { Dialog } from 'primereact/dialog';
import GeneralDialogFooter from '../../shared/GeneralDialogFooter.jsx';
import ShowConfirm from '../../shared/ShowConfirm';
import Table from 'react-bootstrap/Table';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from 'primereact/checkbox';        
import { InputText } from 'primereact/inputtext';
import CityCombo from '../../combos/CityCombo.jsx';
import { FloatLabel } from 'primereact/floatlabel';
import FaDate from '../../shared/FaDate.jsx';
import { InputNumber } from 'primereact/inputnumber';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PrintContraxtBill from '../../prints/PrintContraxtBill.jsx';
import { InputTextarea } from 'primereact/inputtextarea';

var editedModules = [];
var editedParameters = {};
export default function ContractList(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [contracts, setContracts] = useState([]);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
    const [client, setClient] = useState(null);
    const [product, setProduct] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [maxStudentNo, setMaxStudentNo] = useState(0);
    const [maxMemberNo, setMaxMemberNo] = useState(0);
    const [maxClientNo, setMaxClientNo] = useState(0);
    const [maxSchoolNo, setMaxSchoolNo] = useState(0);
    const [maxBillNo, setMaxBillNo] = useState(0);
    const [maxVisitorNo, setMaxVisitorNo] = useState(0);
    const [isPersonal, setIsPersonal] = useState(true);
    const [personNationalId, setPersonNationalId] = useState("");
    const [economicCode, setEconomicCode] = useState("");
    const [companyNationalId, setCompanyNationalId] = useState("");
    const [title, setTitle] = useState("");
    const [otherSystemIdentity, setOtherSystemIdentity] = useState("");
    const [city, setCity] = useState(null);
    const [contractId, setContractId] = useState("");
    const [contractIndex, setContractIndex] = useState(-1);
    const [contractNo, setContractNo] = useState(0);
    const [date, setDate] = useState(0);
    const [newDate, setNewDate] = useState(0);
    const [buyPrice, setBuyPrice] = useState(0);
    const [nextRecontinuePrice, setNextRecontinuePrice] = useState(0);
    const [editFormVisible2, setEditFormVisible2] = useState(false);
    const [sendSmsFormVisible, setSendSmsFormVisible] = useState(false);
    const [smsLink, setSmsLink] = useState("");
    const [searchPanelVisible, setSearchPanelVisible] = useState(false);
    const [searchOptions, setSearchOptions] = useState({client:null, tafsilId:0, mobile:"", fromContractNo:0, toContractNo:0, searchText:"", product:null, cityId:"", provinceId:0});
    const [downloadBillPdfFormVisible, setDownloadBillPdfFormVisible] = useState(false);
    const [contract, setContract] = useState(null);
    const [billParams, setBillParams] = useState(null);
    const [printData, setPrintData] = useState(null);

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = function(){
        setLoading(true);
        var userId = "";
        var mobile = "";
        var fromContractNo = 0;
        var toContractNo = 0;
        var searchText = "";
        var productId = "";
        var cityId = "";
        var provinceId = 0;
        var tafsilId = 0;
        if(searchOptions != null){
            if(searchOptions.client != null)userId = searchOptions.client.id;
            mobile = searchOptions.mobile;
            tafsilId = searchOptions.tafsilId;
            fromContractNo = searchOptions.fromContractNo;
            toContractNo = searchOptions.toContractNo;
            searchText = searchOptions.searchText;
            if(searchOptions.product != null)productId = searchOptions.product.id;
            cityId = searchOptions.cityId;
            provinceId = searchOptions.provinceId;
        }
        var params = {
            login:util.getLoginDto(), 
            userId:userId,
            tafsilId:tafsilId,
            mobile:mobile,
            fromContractNo:fromContractNo,
            toContractNo:toContractNo,
            searchText:searchText,
            productId:productId,
            cityId:cityId,
            provinceId:provinceId,
        };
        var url = config.Server+`/contract/list`;
        console.log("params in show summary is>", params);
        console.log("url in show summary is>", url);
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("setContracts is> ", response);
                for(var i=0;i<response.length;i++){
                    response[i].contract.nextRecontinuePrice -= response[i].taxInNextRecontinueAmount;
                }
                setContracts(response);
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
        console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });

    }
    const onAddNewItemClick = function(){
        setContractId("");
        setContractNo(0);
        setContractIndex(-1);
        editedModules = [];
        editedParameters = {
            maxClientNo:0,
            maxVisitorNo:0,
            maxStudentNo:0,
            maxSchoolNo:0,
            maxMemberNo:0,
            maxBillNo:0,
        };
        setClient(null);
        setProduct(null);
        setSelectedProduct(null);
        setDate(0);
        setNewDate(0);
        setBuyPrice(0);
        setMaxClientNo(0);
        setMaxVisitorNo(0);
        setMaxStudentNo(0);
        setMaxSchoolNo(0);
        setMaxMemberNo(0);
        setMaxBillNo(0);
        setIsPersonal(true);
        setPersonNationalId("");
        setEconomicCode("");
        setCompanyNationalId("");
        setTitle("");
        setOtherSystemIdentity("");
        setCity(null);        
        setEditFormVisible(true);
    }
    const onRowEditClick = function(c, cInd){
        console.log("c is>", c)
        var contract = c.contract;
        console.log("contract is>", contract)
        setContractId(contract.id);
        setContractNo(contract.contractNo);
        setContractIndex(cInd);
        setClient(contract.user);
        setProduct(contract.product);
        setDate(contract.expireDate);
        setNewDate(contract.expireDate);
        setBuyPrice(contract.buyPrice);
        editedModules = [];
        for(var i=0;i<contract.product.modules.length;i++) editedModules.push(contract.product.modules[i].code);
        editedParameters = {
            maxClientNo:0,
            maxVisitorNo:0,
            maxStudentNo:0,
            maxSchoolNo:0,
            maxMemberNo:0,
            maxBillNo:0,
        };
        for(var i=0;i<contract.parameters.length;i++){
            if(contract.parameters[i].parameterType.id == util.ContractParameterTypes.MaxClientNo) editedParameters.maxClientNo = contract.parameters[i].intValue;
            if(contract.parameters[i].parameterType.id == util.ContractParameterTypes.MaxVisitorNo) editedParameters.maxVisitorNo = contract.parameters[i].intValue;
            if(contract.parameters[i].parameterType.id == util.ContractParameterTypes.MaxStudentNo) editedParameters.maxStudentNo = contract.parameters[i].intValue;
            if(contract.parameters[i].parameterType.id == util.ContractParameterTypes.MaxSchoolNo) editedParameters.maxSchoolNo = contract.parameters[i].intValue;
            if(contract.parameters[i].parameterType.id == util.ContractParameterTypes.MaxMemberNo) editedParameters.maxMemberNo = contract.parameters[i].intValue;
            if(contract.parameters[i].parameterType.id == util.ContractParameterTypes.MaxBillNo) editedParameters.maxBillNo = contract.parameters[i].intValue;
        }
        console.log("editedParameters is>", editedParameters)
        setProduct(contract.product);
        //onProductSelected(contract.product, modules);
        setIsPersonal(contract.companyDetail.isPersonal);
        setPersonNationalId(contract.companyDetail.personNationalId);
        setEconomicCode(contract.companyDetail.economicCode);
        setCompanyNationalId(contract.companyDetail.companyNationalId);
        setTitle(contract.companyDetail.title);
        setOtherSystemIdentity(contract.otherSystemIdentity);
        setCity(contract.city);
        setEditFormVisible(true);
    }
    const onRowEditClick2 = function(c, cInd){
        console.log("c is>", c)
        var contract = c.contract;
        console.log("contract is>", contract)
        setContractId(contract.id);
        setContractNo(contract.contractNo);
        setContractIndex(cInd);
        setClient(contract.user);
        setProduct(contract.product);
        setDate(contract.expireDate);
        setNewDate(contract.expireDate);
        setNextRecontinuePrice(contract.nextRecontinuePrice);
        setTitle(contract.companyDetail.title);
        setEditFormVisible2(true);
    }
    const onContractRowPrintClick = function(c, cInd){
        console.log("c is>", c)
        var contract = c.contract;
        console.log("contract is>", contract)
        setContract(c);

        setDownloadBillPdfFormVisible(true);
        setBillParams(null);
        setPrintData(null);

        var params = {
            param1:"", 
            param2:"", 
            param3:"", 
            param4:"", 
            param5:"", 
        };
        var url = config.Server+`/basic/bill-print/parameters/get`;
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setBillParams(response);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });

    }
    const onRowDeleteClick = function(c, cInd){
        var contract = c.contract;
        setContractId(contract.id);
        setContractNo(contract.contractNo);
        setContractIndex(cInd);
        setConfirmDeleteVisible(true);
    }
    const setRowActions = function (row, cInd) {
        return (
        <Row className="justify-content-md-center" style={{}}>
            <Button icon="pi pi-pencil" rounded severity="success" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowEditClick(row, cInd)} title="ویرایش" />
            <Button icon="pi pi-print" rounded severity="info" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onContractRowPrintClick(row, cInd)} title="چاپ" />
            <Button icon="pi pi-stopwatch" rounded severity="primary" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowEditClick2(row, cInd)} title="تنظیم مشخصات تمدید" />
            <Button icon="pi pi-send" rounded severity="warning" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowSendSmsClick(row, cInd)} title="ارسال پیامک لینک تمدید و ارتقاء" />
            {(row.contract.transactions.length == 0)&&(row.contract.installStates.length == 0)?<Button icon="pi pi-trash" rounded severity="danger" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowDeleteClick(row, cInd)} title="حذف" />:<></>}
        </Row>
        );
    }
    const setRowExpireDate = function (row, cInd) {
        var color = "#1ea01eff";
        var extra = "";
        if((row.canBeRecontinued)&&(row.daysToExpired==0)) {color = "#ff0000"; extra="(" +"منقضی" + ")";}
        else if((row.canBeRecontinued)&&(row.daysToExpired>0)) {color = "#ee931bff"; extra="(" +row.daysToExpired + " روز" + ")";}
        return(
            <>
                <div style={{display:"inline-block", width:"16px", height:"16px", borderRadius:"50%", backgroundColor:color}}></div>
                <label style={{color:color}}>&nbsp;{util.toPersianDigits(util.SeperateDate(row.contract.expireDate))}&nbsp;{extra}</label>
            </>
        )
    }
    //=====================================================================================================================================
    //============                  contract edit form              =======================================================================
    //=====================================================================================================================================
    const checkDataEntry = function(){
        console.log("selectedProduct is>", selectedProduct)
        if(client == null){
            setErorVisible(true);
            setErrorMessage("کاربر(مشتری) را انتخاب نمائید");
            return false;
        }
        if(selectedProduct == null){
            setErorVisible(true);
            setErrorMessage("محصول را انتخاب نمائید");
            return false;
        }
        if(newDate<=0){
            setErorVisible(true);
            setErrorMessage("تاریخ انقضاء را مشخص نمائید");
            return false;
        }

        if(selectedProduct.product.productType.id == util.ProductTypes.SchoolManagment){
            if((maxStudentNo <= 0)&&(maxSchoolNo <=0)){
                setErorVisible(true);
                setErrorMessage("حداکثر تعداد دانش آموز یا مدرسه را مشخص نمائید");
                return false;
            }
        }
        else if(selectedProduct.product.productType.id == util.ProductTypes.SandooghManagment){
            if(maxMemberNo <= 0){
                setErorVisible(true);
                setErrorMessage("حداکثر تعداد اعضاء صندوق را مشخص نمائید");
                return false;
            }
        }
        else if(selectedProduct.product.productType.id == util.ProductTypes.TaxSerivce){
            if(maxBillNo <= 0){
                setErorVisible(true);
                setErrorMessage("حداکثر تعداد صورتحساب در سال را مشخص نمائید");
                return false;
            }
        }
        if(title.trim().length < 5){
            setErrorMessage("نام شرکت، موسسه یا فروشگاه را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(isPersonal){
            if(personNationalId.trim().length < 1){
                setErrorMessage("کد ملی را وارد کنید");
                setErorVisible(true);
                return false;
            }
            if(personNationalId.trim().length < 10){
                setErrorMessage("کد ملی معتبر نمی باشد");
                setErorVisible(true);
                return false;
            }
            if((personNationalId.trim().length == 10)&&(!util.IsValidNationalCode(personNationalId))){
                setErrorMessage("کد ملی معتبر نمی باشد");
                setErorVisible(true);
                return false;
            }

        }
        else{
            if(companyNationalId.trim().length < 11){
                setErrorMessage("شناسه ملی شرکت، موسسه یا فروشگاه را وارد کنید");
                setErorVisible(true);
                return false;
            }
        }
        if(city == null){
            setErrorMessage("استان و شهر را مشحص کنید");
            setErorVisible(true);
            return false;
        }
        if(city.cityId < 10){
            setErrorMessage("استان و شهر را مشحص کنید");
            setErorVisible(true);
            return false;
        }

        return true;
    }
    const saveItem = function(){
        if(!checkDataEntry()) return;
        var url = config.Server + `/contract/save`;
        var modules = [];
        for(var i=0;i<selectedProduct.modulesState.length;i++){
            if(selectedProduct.modulesState[i].isChecked){
                modules.push(selectedProduct.modulesState[i].code);
            }
        }
        var parameters = {
            maxClientNo:String(maxClientNo),
            maxVisitorNo:String(maxVisitorNo),
            maxStudentNo:String(maxStudentNo),
            maxSchoolNo:String(maxSchoolNo),
            maxMemberNo:String(maxMemberNo),
            maxBillNo:String(maxBillNo)
        };
        var buyParams = [];
        Object.keys(parameters).forEach(key => {
            if (typeof parameters[key] === "number") {
                buyParams.push({name:key, value:parameters[key].toString()})
            }
            else{
                buyParams.push({name:key, value:parameters[key]});
            }
        });
        var params = {
            login:util.getLoginDto(), 
            userId:client.id,
            contractId:contractId,
            contractNo:contractNo,
            companyDetail:{isPersonal:isPersonal, personNationalId:personNationalId, economicCode:economicCode,companyNationalId:companyNationalId, title:title},
            productId:product.id,
            modules:modules,
            parameters:buyParams,
            expireDate:newDate,
            buyPrice:buyPrice,
            cityId:city.id,
            otherSystemIdentity:otherSystemIdentity
        };
        console.log("save params is>", params);
        setSaving(true);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var ncs = [...contracts];
                response.contract.nextRecontinuePrice -= response.taxInNextRecontinueAmount;
                if(contractIndex == -1){                    
                    ncs.push({...response});                    
                }
                else{
                    ncs[contractIndex] = {...response};
                }
                setContracts(ncs);
                setSaving(false);
                setEditFormVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

    }
    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{setEditFormVisible(false)}} saving={saving} />
        )
    }
    //=====================================================================================================================================
    //============                  recontinue set form             =======================================================================
    //=====================================================================================================================================
    const checkDataEntry2 = function(){
        if(newDate<=0){
            setErorVisible(true);
            setErrorMessage("تاریخ انقضاء را مشخص نمائید");
            return false;
        }
        if(nextRecontinuePrice<=0){
            setErorVisible(true);
            setErrorMessage("مبلغ تمدید را مشخص نمائید");
            return false;
        }

        return true;
    }
    const saveItem2 = function(){
        if(!checkDataEntry2()) return;
        var url = config.Server + `/contract/recontinue/save`;
        var params = {
            login:util.getLoginDto(), 
            contractId:contractId,
            nextRecontinuePrice:nextRecontinuePrice,
            expireDate:newDate,
        };
        setSaving(true);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var ncs = [...contracts];
                response.contract.nextRecontinuePrice -= response.taxInNextRecontinueAmount;
                ncs[contractIndex] = {...response};
                setContracts(ncs);
                setSaving(false);
                setEditFormVisible2(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

    }
    const editDialogFooter2 = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem2()}} onCancelClick={()=>{setEditFormVisible2(false)}} saving={saving} />
        )
    }
    const editDialogFooter3 = function(){
        return (
            <GeneralDialogFooter hideOk={true} onOkClick={()=>{}} onCancelClick={()=>{setDownloadBillPdfFormVisible(false)}} saving={saving} />
        )
    }
    //=====================================================================================================================================
    //============                  recontinue sms form             =======================================================================
    //=====================================================================================================================================
    const onRowSendSmsClick = function(c, cInd){
        console.log("c is>", c)
        var contract = c.contract;
        console.log("contract is>", contract)
        setContractId(contract.id);
        setContractNo(contract.contractNo);
        setContractIndex(cInd);

        var url = config.Server + `/contract/recontinue/sms/get`;
        var params = {
            login:util.getLoginDto(), 
            contractId:contract.id,
        };
        setSaving(true);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setSaving(false);
                setSmsLink(response);
                setSendSmsFormVisible(true);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });
    }
    const checkDataEntry3 = function(){
        return true;
    }
    const saveItem3 = function(){
        if(!checkDataEntry3()) return;
        var url = config.Server + `/contract/recontinue/sms/send`;
        var params = {
            login:util.getLoginDto(), 
            contractId:contractId,
        };
        setSaving(true);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setSaving(false);
                setSendSmsFormVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

    }
    const sendSmsDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem3()}} onCancelClick={()=>{setSendSmsFormVisible(false)}} saving={saving} />
        )
    }
    //=====================================================================================================================================
    const deleteItem = function(){
        setDeleting(true);
        var params = {login:util.getLoginDto(), id:contractId};
        var url = config.Server+`/contract/delete`;
        axios
            .post(url, params )
            .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                var ncs = [...contracts];
                ncs.splice(contractIndex, 1);
                setContracts(ncs);

                setDeleting(false);
                setConfirmDeleteVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
            })
            .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }
    const onProductSelected = function(value){
        console.log("selected product is>", value)
        setProduct(value);
        if(!value) {
            setSelectedProduct(null);
            return;
        }
        var res = { };
        var modulesState = [];
        for(var i=0;i<value.modules.length;i++){
            var m = {...value.modules[i]};
            m["isChecked"] = m.isMandatory;
            if(!m.isMandatory){
                if(editedModules){
                    if(editedModules.includes(m.code))m["isChecked"] = true;
                    else m["isChecked"] = false;
                }
            }
            modulesState.push(m);
        }
        res["product"] = value;
        res["modulesState"] = modulesState;
        setSelectedProduct(res);
        
        if(editedParameters){
            setMaxClientNo(editedParameters.maxClientNo);
            setMaxVisitorNo(editedParameters.maxVisitorNo);
            setMaxStudentNo(editedParameters.maxStudentNo);
            setMaxSchoolNo(editedParameters.maxSchoolNo);
            setMaxMemberNo(editedParameters.maxMemberNo);
            setMaxBillNo(editedParameters.maxBillNo);
            
        }
        else{
            setMaxClientNo(0);
            setMaxVisitorNo(0);
            setMaxStudentNo(0);
            setMaxSchoolNo(0);
            setMaxMemberNo(0);
            setMaxBillNo(0);
        }
        
    }
    const onModuleCheckChanged = (code, value, ind) => {
        var res = {...selectedProduct};
        res.modulesState[ind].isChecked = !value;
        setSelectedProduct(res);
    };    
    const onBuyPriceChanged = function(e){
        if(e.value){
            setBuyPrice(e.value);
        }
        else{
            setBuyPrice(0);
        }
    }
    const onNextRecontinuePriceChanged = function(e){
        if(e.value){
            setNextRecontinuePrice(e.value);
        }
        else{
            setNextRecontinuePrice(0);
        }
    }
    const onContractNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setContractNo(v);
    }
    const onOtherSystemIdentityChanged = (value) =>{
        var v = "";
        if(value == null) v = "";
        else v = value;
        setOtherSystemIdentity(v);
    }
    const onMaxClientNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxClientNo(v);
    }

    const onMaxVisitorNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxVisitorNo(v);
    }
    const onMaxStudentNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxStudentNo(v);
        setMaxSchoolNo(0);
    }
    const onMaxSchoolNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxStudentNo(0);
        setMaxSchoolNo(v);
    }
    const onMaxMemberNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxMemberNo(v);
    }
    const onMaxBillNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxBillNo(v);
    }
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "personNationalId") setPersonNationalId(val);
        else if(name === "economicCode") setEconomicCode(val);
        else if(name === "companyNationalId") setCompanyNationalId(val);
        else if(name === "title") setTitle(val);
    }
    const onSearchInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        var so = {...searchOptions};
        if((name === "mobile")||(name === "searchText")) so[name] = val;
        else if((name === "fromContractNo")||(name === "toContractNo")) {
            if(val == "") val = "0";
            so[name] = parseInt(val);
            if(name == "fromContractNo") so["toContractNo"] = parseInt(val);
        }
        setSearchOptions(so);
    }
    const onSearchProductSelected = function(value){
        console.log("selected product is>", value)
        var so = {...searchOptions};
        if(value){
            so["product"] = value;
        }
        else{
            so["product"] = null;
        }
        setSearchOptions(so);
        
    }
    const onSearchClientSelected = function(value){
        console.log("selected product is>", value)
        var so = {...searchOptions};
        if(value){
            so["client"] = value;
        }
        else{
            so["client"] = null;
        }
        setSearchOptions(so);
        
    }
    const printBill = function(ind){
        var tr = contract.contract.transactions[ind];
        var res = {
            issueDate: tr.transactionDate,
            contractNo: contract.contract.contractNo,
            price: tr.amount - tr.tax + tr.discount,
            discount: tr.discount,
            tax: tr.tax,
            purePrice: tr.amount,
            stuffTitle: 0,
            modules:[],
            parameters: [],
            companyDetail: contract.contract.companyDetail,
            city:contract.contract.city,
            user:contract.contract.user
        }
        if(tr.transactionType.id == util.ContractTransactionTypes.Buy){
            res.stuffTitle = "خرید " + contract.contract.product.productType.title;
            res.modules = [...contract.contract.product.modules]
            res.parameters = [...contract.contract.parameters]
        }
        else if(tr.transactionType.id == util.ContractTransactionTypes.Recontinue){
            res.stuffTitle = "تمدید مجوز " + contract.contract.product.productType.title;
            res.modules = [...contract.contract.product.modules]
            res.parameters = [...contract.contract.parameters]
        }
        else if(tr.transactionType.id == util.ContractTransactionTypes.PromoteModule){
            res.stuffTitle = "ارتقاء ماژول های قرارداد " + contract.contract.product.productType.title;
            res.modules = [...tr.propmotedModules];
            res.parameters = [];
        }
        else if(tr.transactionType.id == util.ContractTransactionTypes.PromoteParameter){
            var prs = [];
            for(var i=0;i<tr.promotedParameters.length;i++){
                if(parseInt(tr.promotedParameters[i].value)>0){
                    var p = {intValue:parseInt(tr.promotedParameters[i].value)};
                    if(tr.promotedParameters[i].name == "maxClientNo") p["parameterType"] = {id:util.ContractParameterTypes.MaxClientNo, title:"حداکثر تعداد دستگاه نصب"};
                    else if(tr.promotedParameters[i].name == "maxVisitorNo") p["parameterType"] = {id:util.ContractParameterTypes.MaxVisitorNo, title:"حداکثر تعداد ویزیتور"};
                    else if(tr.promotedParameters[i].name == "maxStudentNo") p["parameterType"] = {id:util.ContractParameterTypes.MaxStudentNo, title:"حداکثر تعداد دانش آموز"};
                    else if(tr.promotedParameters[i].name == "maxSchoolNo") p["parameterType"] = {id:util.ContractParameterTypes.MaxSchoolNo, title:"حداکثر تعداد مدرسه"};
                    else if(tr.promotedParameters[i].name == "maxMemberNo") p["parameterType"] = {id:util.ContractParameterTypes.MaxMemberNo, title:"حداکثر تعداد عضو"};
                    else if(tr.promotedParameters[i].name == "maxBillNo") p["parameterType"] = {id:util.ContractParameterTypes.MaxBillNo, title:"حداکثر تعداد صورتحساب در سال"};
                    prs.push(p);
                }
            }
            res.stuffTitle = "ارتقاء پارامترهای قرارداد " + contract.contract.product.productType.title;
            res.modules = [];
            res.parameters = prs;
        }

        setPrintData(res)
    }
    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(smsLink);
        alert("✅ لینک با موفقیت کپی شد!");
      } catch (err) {
        console.error("خطا در کپی:", err);
        alert("❌ کپی انجام نشد!");
      }
    };
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loading)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت لیست قرارداد ها..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            
            
            <div style={{textAlign:"center", padding:"5px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px"}}>
                لیست قراردادها
            </div>
            {
              searchPanelVisible?
              <Row style={{border:"1px dashed #b0b0b0", padding:"5px", margin:"10px 0px 0px 0px"}}>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <InputText value={searchOptions.mobile} onChange={(e)=>{onSearchInputChange(e, "mobile")}} id="mobile" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={11} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                        <label htmlFor="mobile">موبایل مشتری</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"0px"}}>
                    <ClientCombo onChange={(val)=>{onSearchClientSelected(val)}} value={searchOptions.client} includeAdmins={false} includeAssistants={false} includeAgents={true} includeClients={true}/>
                </Col>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <InputText value={searchOptions.fromContractNo} onChange={(e)=>{onSearchInputChange(e, "fromContractNo")}} id="fromContractNo" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={8} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                        <label htmlFor="fromContractNo">از شماره قرارداد</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <InputText value={searchOptions.toContractNo} onChange={(e)=>{onSearchInputChange(e, "toContractNo")}} id="toContractNo" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={8} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                        <label htmlFor="toContractNo">تا شماره قرارداد</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <InputText value={searchOptions.searchText} onChange={(e)=>{onSearchInputChange(e, "searchText")}} id="searchText" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                        <label htmlFor="searchText">موسسه</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"0px"}}>                
                    <ProductCombo onChange={(val)=>{onSearchProductSelected(val.product);}} value={searchOptions.product} />
                </Col>
                <Col md={12} style={{marginTop:"30px"}}>
                    <Button label="&nbsp;&nbsp;  جستجو کن  &nbsp;&nbsp;" icon="pi pi-search" onClick={()=>loadItems()} severity="primary" iconPos="right" style={{borderRadius:"5px"}} />
                </Col>
              </Row>
              :<></>
            }

              <Row style={{}}>
                <Col xs={12} md={3}>
                    <table style={{width:"100%"}}>
                        <tbody>
                        <tr>
                            <td style={{padding:"5px"}}><Button label="" icon="pi pi-search" onClick={()=>setSearchPanelVisible(!searchPanelVisible)} severity="secondary" iconPos="right" style={{borderRadius:"5px"}} /></td>
                            <td style={{padding:"5px"}}><Button label="ثبت قرارداد جدید" icon="pi pi-plus" onClick={()=>onAddNewItemClick()} severity="secondary" iconPos="right" style={{borderRadius:"5px"}} /></td>
                        </tr>
                        </tbody>
                    </table>
                </Col>
              </Row>

              <DataTable value={contracts} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id">
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="contract.id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="contract.tafsilId" header={"تفضیل"} body={(row) => (util.toPersianDigits(row.contract.tafsilId) )} sortable className="list-cell-text-align"></Column>
                <Column field="contract.contractNo" header={"شماره"} body={(row) => (util.toPersianDigits(row.contract.contractNo) )} sortable className="list-cell-text-align"></Column>
                <Column field="contract.expireDate" header={"انقضاء"} body={(row, options) => setRowExpireDate(row, options.rowIndex)} sortable className="list-cell-text-align"></Column>
                <Column field="contract.product.productType.title" body={(row) => row.contract.product.productType.title} header={"نوع محصول"} sortable className="list-cell-text-align"></Column>
                <Column field="contract.user.lastname" body={(row) => (row.contract.user.firstname + " " + row.contract.user.lastname)} header={"مشتری"} sortable className="list-cell-text-align"></Column>
                <Column field="contract.companyDetail.title" header={"موسسه"} sortable className="list-cell-text-align"></Column>
                <Column field="contract.nextRecontinuePrice" body={(row) => (util.toPersianDigits(util.SeperatePrice(row.contract.nextRecontinuePrice)) )} header={"مبلغ تمدید"} sortable className="list-cell-text-align"></Column>
                <Column body={(row, options) => setRowActions(row, options.rowIndex)} exportable={false} style={{ }}></Column>
              </DataTable>

            {
                editFormVisible?
                <Dialog visible={true} style={{ width: '50rem', height:"calc(100vh - 100px)" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="ثبت مشخصات قرارداد" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => setEditFormVisible(false)}>
                    <Row>
                        <Col>
                            <ClientCombo onChange={(val)=>{setClient(val)}} value={client} includeAdmins={false} includeAssistants={false} includeAgents={true} includeClients={true}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <ProductCombo onChange={(val)=>{onProductSelected(val.product);}} value={product} />
                        </Col>
                    </Row>
                    {
                    (!selectedProduct)||(selectedProduct == null)?<></>:
                    <>
                    <Row style={{marginTop:"20px"}}>
                        <Col>
                            <div style={{border:"1px solid #b0b0b0", borderRadius:"5px"}}>
                                <div style={{backgroundColor:"#ebebebff", padding:"12px"}}>انتخاب ماژول های مورد نیاز</div>
                                <div style={{padding:"10px 0px 2px 0px"}}>
                                    <Table hover striped key={"moduletable"}>
                                        <tbody  key={"moduletablebody"}>
                                        {
                                            selectedProduct.modulesState.map((m, mInd)=>{
                                                return(
                                                    <tr key={"tr_" + String(mInd)}>
                                                        <td style={{borderBottom:"0px"}} key={"td1_" + String(mInd)}>
                                                            <div key={"divCheckBox_"+String(mInd)} className="flex align-items-center">
                                                                <Checkbox disabled={m.isMandatory} value={m.isChecked} inputId={"chkModule_"+String(mInd)} onChange={(e)=>onModuleCheckChanged(m.code, e.value, mInd)} checked={m.isChecked} />
                                                                <label htmlFor={"chkModule_"+String(mInd)} className="ml-2">&nbsp;{m.title}</label>
                                                            </div>
                                                        </td>
                                                        <td style={{borderBottom:"0px"}} key={"td2_" + String(mInd)}>
                                                            {util.SeperatePrice(m.price)}
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        </tbody>
                                    </Table>
                                </div>
                            </div>        
                        </Col>
                    </Row>
                    <Row style={{marginTop:"20px"}}>
                        <Col>
                            <div style={{border:"1px solid #b0b0b0", borderRadius:"5px"}}>
                                <div style={{backgroundColor:"#ebebebff", padding:"12px"}}>تنظیم پارامترها</div>
                                <div style={{padding:"10px 0px 10px 0px"}}>
                                    <Table key={"parametertable"}>
                                        <tbody  key={"parametertablebody"}>
                                            <tr>
                                                <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>شماره قرارداد</td>
                                                <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                    <InputText disabled={contractIndex>=0} value={contractNo} onChange={(e) => onContractNoChanged(e.target.value)} onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} style={{width:"120px", textAlign:"center", direction:"ltr"}} maxLength={6} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>شناسه در سیستم دیگر</td>
                                                <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                    <InputText value={otherSystemIdentity} onChange={(e) => onOtherSystemIdentityChanged(e.target.value)} keyfilter="" style={{width:"220px", textAlign:"center", direction:"ltr"}} maxLength={50} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تاریخ انقضاء</td>
                                                <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                    <FaDate value={date} onChange={(val)=>setNewDate(val)} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>قیمت خرید</td>
                                                <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                    <InputNumber value={buyPrice} onChange={(e) => {onBuyPriceChanged(e)}} onValueChange={(e) => {onBuyPriceChanged(e)}} minFractionDigits={0} maxFractionDigits={0} style={{direction:"ltr", textAlign:"center", width:"120px"}} />
                                                </td>
                                            </tr>
                                        {
                                            (selectedProduct.product.productType.id == util.ProductTypes.WinHanaAccounting)?
                                            <>
                                            <tr>
                                                <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تعداد دستگاه برای نصب</td>
                                                <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                    <InputText value={maxClientNo} onChange={(e) => onMaxClientNoChanged(e.target.value)} onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={4} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تعداد ویزیتور</td>
                                                <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                    <InputText value={maxVisitorNo} onChange={(e) => onMaxVisitorNoChanged(e.target.value)} onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={4} />
                                                </td>
                                            </tr>
                                            </>
                                            :<></>
                                        }
                                        {
                                            (selectedProduct.product.productType.id == util.ProductTypes.SchoolManagment)?
                                            <>
                                            <tr>
                                                <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>حداکثر تعداد دانش آموز</td>
                                                <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                    <InputText value={maxStudentNo} onChange={(e) => onMaxStudentNoChanged(e.target.value)} onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={4} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تعداد مدارس تابعه</td>
                                                <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                    <InputText value={maxSchoolNo} onChange={(e) => onMaxSchoolNoChanged(e.target.value)} onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={4} />
                                                </td>
                                            </tr>
                                            </>
                                            :
                                            <></>
                                        }
                                        {
                                            (selectedProduct.product.productType.id == util.ProductTypes.SandooghManagment)?
                                            <>
                                            <tr>
                                                <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>حداکثر تعداد اعضای صندوق</td>
                                                <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                    <InputText value={maxMemberNo} onChange={(e) => onMaxMemberNoChanged(e.target.value)} onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={5} />
                                                </td>
                                            </tr>
                                            </>
                                            :
                                            <></>
                                        }
                                        {
                                            (selectedProduct.product.productType.id == util.ProductTypes.TaxSerivce)?
                                            <>
                                            <tr>
                                                <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>حداکثر تعداد فاکتور در سال</td>
                                                <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                    <InputText value={maxBillNo} onChange={(e) => onMaxBillNoChanged(e.target.value)} onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={5} />
                                                </td>
                                            </tr>
                                            </>
                                            :
                                            <></>
                                        }
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{marginTop:"20px"}}> 
                        <Col>
                            <div style={{border:"1px solid #b0b0b0", borderRadius:"5px"}}>
                                <div style={{backgroundColor:"#ebebebff", padding:"12px"}}>ثبت مشخصات شرکت، موسسه یا فروشگاه</div>
                                <div style={{padding:"10px 0px 10px 0px"}}>
                                    <table style={{width:"calc(100% - 30px)", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                                        <tbody>
                                            <tr><td>&nbsp;</td></tr>
                                            <tr>
                                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                                    <FloatLabel>
                                                        <InputText value={title} onChange={(e)=>{onInputChange(e, "title")}} id="title" keyfilter="" maxLength={200} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                                        <label htmlFor="title">نام شرکت، موسسه یا فروشگاه</label>
                                                    </FloatLabel>                                                    
                                                </td>
                                            </tr>
                                            <tr><td>&nbsp;</td></tr>
                                            <tr>
                                                <td style={{fontSize:"1em"}}>
                                                    <Row>
                                                        <Col>
                                                            <div className="flex align-items-center">
                                                                <RadioButton inputId="isPersonal" name="pizza" value={true} onChange={(e) => setIsPersonal(e.value)} checked={isPersonal === true} />
                                                                <label htmlFor="isPersonal" className="ml-2">&nbsp;&nbsp;حقیقی</label>
                                                            </div>
                                                        </Col>
                                                        <Col>
                                                        <div className="flex align-items-center">
                                                            <RadioButton inputId="isCompany" name="pizza" value={false} onChange={(e) => setIsPersonal(e.value)} checked={isPersonal === false} />
                                                            <label htmlFor="isCompany" className="ml-2">&nbsp;&nbsp;حقوقی</label>
                                                        </div>
                                                        </Col>
                                                    </Row>
                                                </td>
                                            </tr>
                                            {
                                                isPersonal?
                                                <>
                                                    <tr><td>&nbsp;</td></tr>
                                                    <tr>
                                                        <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                                            <FloatLabel>
                                                                <InputText value={personNationalId} onChange={(e)=>{onInputChange(e, "personNationalId")}} id="personNationalId" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={12} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                                                <label htmlFor="personNationalId">کد ملی</label>
                                                            </FloatLabel>
                                                            
                                                        </td>
                                                    </tr>
                                                    <tr><td>&nbsp;</td></tr>
                                                    <tr>
                                                        <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                                            <FloatLabel>
                                                                <InputText value={economicCode} onChange={(e)=>{onInputChange(e, "economicCode")}} id="economicCode" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={12} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                                                <label htmlFor="economicCode">کد اقتصادی</label>
                                                            </FloatLabel>
                                                            
                                                        </td>
                                                    </tr>
                                                </>
                                                :
                                                <>
                                                    <tr><td>&nbsp;</td></tr>
                                                    <tr>
                                                        <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                                            <FloatLabel>
                                                                <InputText value={companyNationalId} onChange={(e)=>{onInputChange(e, "companyNationalId")}} id="companyNationalId" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={11} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                                                <label htmlFor="companyNationalId">شناسه ملی</label>
                                                            </FloatLabel>
                                                            
                                                        </td>
                                                    </tr>
                                                </>
                                            }
                                            <tr><td>&nbsp;</td></tr>
                                            <tr>
                                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                                    <CityCombo horizontal={false} value={city} onChange={(value)=>{setCity(value);console.log("city is>", value)}} />
                                                    
                                                </td>
                                            </tr>
                                            <tr><td>&nbsp;</td></tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>               
                    </Row>
                    </>
                    }

                </Dialog>
                :
                <></>
            }

            {
                editFormVisible2?
                <Dialog visible={true} style={{ width: '50rem', height:"calc(100vh - 100px)" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="ثبت مشخصات تمدید قرارداد" modal className="p-fluid" footer={() => editDialogFooter2()} onHide={() => setEditFormVisible2(false)}>
                    <Row>
                        <Col>
                            <Table key={"parametertable"} style={{marginTop:"20px"}}>
                                <tbody  key={"parametertablebody"}>
                                    <tr>
                                        <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>شماره قرارداد</td>
                                        <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                            {util.toPersianDigits(contractNo)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>مشتری</td>
                                        <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                            {client.tafsilId + " " +  client.firstname + " " + client.lastname}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>نام موسسه</td>
                                        <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                            {title}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>محصول</td>
                                        <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                            {product.productType.title}
                                        </td>
                                    </tr>
                                    <tr><td>&nbsp;</td></tr>
                                    <tr>
                                        <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تاریخ انقضاء</td>
                                        <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                            <FaDate value={date} onChange={(val)=>setNewDate(val)} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>مبلغ تمدید قرارداد</td>
                                        <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                            <InputNumber value={nextRecontinuePrice} onChange={(e) => {onNextRecontinuePriceChanged(e)}} onValueChange={(e) => {onNextRecontinuePriceChanged(e)}} minFractionDigits={0} maxFractionDigits={0} style={{direction:"ltr", textAlign:"center", width:"120px"}} />
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>

                </Dialog>
                :
                <></>
            }

            {
                sendSmsFormVisible?
                <Dialog visible={true} style={{ width: '50rem', height:"400px" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="ارسال پیامک لینک تمدید یا ارتقاء قرارداد" modal className="p-fluid" footer={() => sendSmsDialogFooter()} onHide={() => setSendSmsFormVisible(false)}>
                    <Row>
                        <Col>
                            <Table key={"sendsmstable"} style={{marginTop:"20px"}}>
                                <tbody  key={"sendsmstablebody"}>
                                    <tr>
                                        <td style={{textAlign:"right", padding:"5px"}}>
                                            <InputTextarea readOnly={true} disabled={false} value={smsLink} style={{direction:"ltr", width:"100%", height:"150px"}} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{textAlign:"right", padding:"5px"}}>
                                            <Button severity="success" onClick={()=>{handleCopy()}} style={{borderRadius:"5px", width:"100px"}} iconPos="right" icon="pi pi-copy">&nbsp;&nbsp;کپی&nbsp;&nbsp;</Button>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>

                </Dialog>
                :
                <></>
            }

            {
                downloadBillPdfFormVisible?
                <Dialog visible={true} style={{ width: '50rem', height:"calc(100vh - 100px)" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="دانلود فاکتور قرارداد" modal className="p-fluid" footer={() => editDialogFooter3()} onHide={() => setDownloadBillPdfFormVisible(false)}>
                    {
                    billParams == null?
                    <>
                        <Row>
                            <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                                <Laoding showLable={true} label="در حال دریافت پارامترهای چاپ..." />
                            </Col>
                        </Row>
                    </>
                    :
                    printData == null?
                        contract.contract.transactions.map((tr, trInd)=>{
                            return(
                                <>
                                    <div style={{width:"calc(100% - 10px)", height:"98px", margin:"10px 0px", borderRadius:"5px", border:"1px solid #b0b0b0", padding:"5px", position:"relative"}}>
                                        <table style={{width:"100%", borderCollapse:"collapse"}}>
                                            <tbody>
                                                <tr>
                                                    <td style={{width:"100px", border:"1px dashed #d0d0d0", padding:"3px", textAlign:"center", fontWeight:"bold"}} colSpan={2}>{tr.transactionType.title}</td>
                                                    <td style={{textAlign:"center", verticalAlign:"middle"}} rowSpan={3}>
                                                        <Button label="&nbsp;&nbsp;  چاپ  &nbsp;&nbsp;" icon="pi pi-print" onClick={()=>printBill(trInd)} severity="info" iconPos="right" style={{borderRadius:"5px", width:"110px"}} />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"left", border:"1px dashed #d0d0d0", padding:"3px"}}>تاریخ</td>
                                                    <td style={{border:"1px dashed #d0d0d0", padding:"3px"}}>{util.toPersianDigits(util.SeperateDate(tr.transactionDate))}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"left", border:"1px dashed #d0d0d0", padding:"3px"}}>مبلغ</td>
                                                    <td style={{border:"1px dashed #d0d0d0", padding:"3px"}}>{util.toPersianDigits(util.SeperatePrice(tr.amount))}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )
                        })
                    :
                    <>
                        <Row>
                            <Col className="d-flex justify-content-center align-items-center" style={{height:"100px"}}>
                                جهت دانلود فایل صورتحساب بر روی لینک زیر کلیک نمائید
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center align-items-center" style={{height:"30px"}}>
                                <PDFDownloadLink  style={{textDecoration:"0px"}}
                                document={<PrintContraxtBill 
                                    data={{bill:printData, params:billParams}} 
                                    />} fileName={"hana_bill_"+util.generateRandomUString(10)+".pdf"}>
                                    <label style={{fontSize:"14pt", cursor:"pointer"}}>دانلود صورتحساب!</label>
                                </PDFDownloadLink>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-center align-items-center" style={{height:"100px"}}>
                               <label style={{cursor:"pointer", color:"#5656e0"}} onClick={()=>setPrintData(null)}>برگشت به لیست چاپ</label>
                            </Col>
                        </Row>
                    </>
                    }
                </Dialog>
                :
                <></>
            }
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
            <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
        </>
    )
}